import { useCallback, useEffect, useState } from 'react';
import ManufacturerListTable from './ManufacturerListTable';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import AddManufacturerModal from './AddManufacturerModal';
import ManufacturerApi from '../../Api/ManufacturerApi';
import { Manufacturer } from '../../Models/Manufacturer';

export default function ManufacturerList() {
  const { userModel } = useAppSelector((state) => state.user);
  const [manufacturerAllListData, setManufacturerListData] = useState<
    Manufacturer[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAddManufacturer, setShowAddManufacturer] =
    useState<boolean>(false);

  const getManufacturers = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return ManufacturerApi.getManufacturerList()
          .then((res) => {
            setManufacturerListData(res.data);

            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [userModel]);

  useEffect(() => {
    setTimeout(() => {
      getManufacturers();
    }, 100);
  }, []);

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Manufacturers</div>
              </h1>
            </div>
          </div>
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
            <ManufacturerListTable data={manufacturerAllListData} />
          </div>
        </div>
      </div>
      <AddManufacturerModal
        show={showAddManufacturer}
        setShow={setShowAddManufacturer}
        getManufacturers={getManufacturers}
      />
    </>
  );
}
